module.exports = __webpack_public_path__ + "static/media/Jester.02895296.jpg";